import { Link } from 'react-router-dom';
import { Img } from 'react-image';
import { Navbar } from 'flowbite-react';
import { useThemeContext } from 'src/context/ThemeProvider';
type Props = {
	showNavbar?: boolean;
};

const UnAuthorizedParticipantScreen = ({ showNavbar = true }: Props) => {
	const { themeMode } = useThemeContext();
	return (
		<div className="h-screen w-screen dark:text-white">
			{showNavbar && (
				<Navbar
					className={`rounded-none w-full !px-[45px] sm:!px-[10px] bg-white dark:bg-[#18222D]`}
					fluid={true}
					rounded={true}
				>
					<div className="flex gap-8 items-center ">
						<Link to="/" className="flex items-center ">
							<Img
								loading="lazy"
								src={
									themeMode === 'dark'
										? 'https://masai-website-images.s3.ap-south-1.amazonaws.com/Levelup-Logo.png'
										: 'https://masai-website-images.s3.ap-south-1.amazonaws.com/Levelup-Logo.png'
								}
								width="110"
								height="32px"
								alt="LevelUp Logo"
							/>
						</Link>
					</div>
				</Navbar>
			)}
			<div className="h-full w-full dark:text-white flex flex-col gap-2 justify-center items-center">
				<p className=" text-2xl font-bold">Meeting is for authorized participants only</p>
				<p className=" text-base">Kindly login with authorised email address before joining the meeting.</p>
			</div>
		</div>
	);
};

export default UnAuthorizedParticipantScreen;
